import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinbhor() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Bhor',
        heading: 'Urbania on rent in pune: Urbania On Rent in Bhor',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Bhor for corporate groups, families, tourists, and event travelers planning trips to and from Bhor. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Bhor. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Bhor.',

        top: 'Top Places to Visit in Bhor with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Bhatghar Dam",
    "description": "Bhatghar Dam is one of the oldest dams in Maharashtra and a major attraction near Bhor. Built on the Yelwandi River, the dam is surrounded by lush green hills and vast water views that become especially beautiful during the monsoon. The cool breeze, misty atmosphere, and scenic surroundings make it a perfect spot for nature lovers, photography enthusiasts, and peaceful relaxation away from city crowds."
  },
  {
    "title": "Baneshwar Temple",
    "description": "Baneshwar Temple is an ancient and spiritually significant temple dedicated to Lord Shiva, located near Bhor amidst dense forest surroundings. The temple complex also includes a sacred water tank and walking trails that add to its serene ambiance. It is a popular picnic and pilgrimage spot, especially during Mahashivratri, attracting devotees and families seeking spiritual peace and natural beauty."
  },
  {
    "title": "Necklace Point (Bhor Ghat Viewpoint)",
    "description": "Necklace Point is a scenic viewpoint offering panoramic views of the winding roads, hills, and valleys of the Bhor region. The viewpoint is especially mesmerizing during monsoon when clouds float through the valleys and greenery surrounds every direction. It is a favorite spot for photography, short halts, and enjoying the breathtaking Western Ghats landscape."
  },
  {
    "title": "Raireshwar Temple",
    "description": "Raireshwar Temple holds immense historical importance as the place where Chhatrapati Shivaji Maharaj took an oath of Swarajya. Situated atop a hill near Bhor, the temple offers stunning views of surrounding valleys and plateaus. The peaceful environment, combined with its Maratha legacy, makes it a must-visit for history lovers, trekkers, and spiritual seekers."
  },
  {
    "title": "Kapurhol Ghat",
    "description": "Kapurhol Ghat is a scenic mountain pass near Bhor known for its curving roads, forested hills, and misty monsoon views. Travelers passing through the ghat enjoy lush greenery, waterfalls, and cool weather during the rainy season. It is a pleasant driving route and a great place to experience the natural charm of the Sahyadri ranges."
  },
  {
    "title": "Vajragad (Rudramal) Fort",
    "description": "Vajragad Fort, also known as Rudramal, is a historic hill fort near Bhor associated with Maratha history. The fort offers trekking opportunities, ancient ruins, rock-cut steps, and panoramic views of the surrounding plateau. It is ideal for adventure enthusiasts who enjoy offbeat treks combined with historical exploration."
  },
  {
    "title": "Nira River View Points",
    "description": "The Nira River flows close to Bhor and offers several calm viewpoints along its banks. These spots are ideal for relaxing walks, picnics, and enjoying the rural countryside. During monsoon and post-monsoon seasons, the riverbanks become lush and scenic, providing a refreshing escape into nature."
  },
  {
    "title": "Sangameshwar Temple",
    "description": "Sangameshwar Temple is a local spiritual landmark dedicated to Lord Shiva, situated near the confluence of small rivers around Bhor. The temple is known for its peaceful environment, traditional rituals, and cultural importance to nearby villages. It is often visited during religious festivals and fairs."
  },
  {
    "title": "Local Village Life Experience",
    "description": "Bhor is surrounded by traditional Maharashtrian villages that offer an authentic rural experience. Visitors can observe farming activities, bullock carts, simple homes, and warm local hospitality. This experience provides insight into the agrarian lifestyle, culture, and traditions of the Western Maharashtra region."
  },
  {
    "title": "Monsoon Waterfalls Around Bhor",
    "description": "During the monsoon season, several small and seasonal waterfalls appear around Bhor, flowing through hills and forest patches. These waterfalls create picturesque landscapes and are ideal for photography, short hikes, and nature exploration. The fresh air, greenery, and sound of flowing water make monsoon visits especially memorable."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Bhor",
      "description": "Urbania on Rent in Bhor provides fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Well-maintained vehicles and professional chauffeurs ensure a smooth, safe, and reliable travel experience for all passengers."
    },
    {
      "name": "Bhor Urbania Bus Hire",
      "description": "Bhor Urbania Bus Hire offers spacious, fully air-conditioned buses for group travel, corporate tours, and social events. With comfortable seating and trained chauffeurs, every journey is safe, enjoyable, and stress-free."
    },
    {
      "name": "Urbania Rental Service Bhor",
      "description": "Urbania Rental Service Bhor delivers premium Urbania vehicles suitable for family trips, corporate travel, sightseeing, and leisure outings. Experienced chauffeurs provide convenient, safe, and reliable travel at all times."
    },
    {
      "name": "Urbania AC Bus on Rent Bhor",
      "description": "Urbania AC Bus on Rent Bhor provides fully air-conditioned buses for long-distance travel, group tours, and corporate events. Spacious seating and experienced drivers ensure a comfortable, safe, and hassle-free journey."
    },
    {
      "name": "Corporate Urbania Hire Bhor",
      "description": "Corporate Urbania Hire Bhor offers dependable transportation for office trips, employee commutes, and corporate events. Professional chauffeurs and punctual service ensure smooth, professional, and reliable travel solutions."
    },
    {
      "name": "Urbania for Outstation Bhor",
      "description": "Urbania for Outstation Bhor provides safe and comfortable long-distance travel with air-conditioned vehicles. Experienced drivers guarantee a smooth ride to nearby cities, tourist destinations, and corporate locations."
    },
    {
      "name": "Urbania Airport Transfer Bhor",
      "description": "Urbania Airport Transfer Bhor ensures timely airport pickups and drops. Spacious, well-maintained vehicles with professional chauffeurs provide convenient, safe, and stress-free airport transportation."
    },
    {
      "name": "Luxury Urbania Bhor",
      "description": "Luxury Urbania Bhor offers high-end air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs provide premium travel experience with comfort, style, and safety."
    },
    {
      "name": "Affordable Urbania Hire Bhor",
      "description": "Affordable Urbania Hire Bhor provides budget-friendly Urbania rental services without compromising on quality or comfort. Ideal for families, groups, and corporate clients seeking value-for-money transportation."
    },
    {
      "name": "Chauffeur Driven Urbania Bhor",
      "description": "Chauffeur Driven Urbania Bhor provides stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles ensure smooth, safe, and enjoyable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Bhor",
      "description": "Urbania for Wedding Events Bhor offers elegant air-conditioned vehicles for weddings, guests, and family members. Professional chauffeurs ensure stylish, punctual, and hassle-free wedding transportation."
    },
    {
      "name": "Urbania for Office Trips Bhor",
      "description": "Urbania for Office Trips Bhor delivers comfortable and reliable transportation for daily office commutes, team outings, and corporate events. Focused on convenience and punctuality, it ensures smooth travel for employees and teams."
    },
    {
      "name": "Best Urbania Rental Bhor",
      "description": "Best Urbania Rental Bhor provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Ideal for corporate travel, family trips, and group outings requiring premium and hassle-free transportation."
    },
    {
      "name": "Urbania Group Travel Bhor",
      "description": "Urbania Group Travel Bhor offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel experiences."
    },
    {
      "name": "Reliable Urbania Hire Bhor",
      "description": "Reliable Urbania Hire Bhor ensures trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs provide convenient, comfortable, and dependable travel experiences for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Bhor", "Bhor Urbania Bus Hire"],
    ["Urbania Rental Service Bhor", "Urbania AC Bus on Rent Bhor"],
    ["Corporate Urbania Hire Bhor", "Urbania for Outstation Bhor"],
    ["Urbania Airport Transfer Bhor", "Luxury Urbania Bhor"],
    ["Affordable Urbania Hire Bhor", "Chauffeur Driven Urbania Bhor"],
    ["Urbania for Wedding Events Bhor", "Urbania for Office Trips Bhor"],
    ["Best Urbania Rental Bhor", "Urbania Group Travel Bhor"],
    ["Reliable Urbania Hire Bhor", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Bhor",
        "WhyChoosedescription": "Urbania On Rent in Bhor is perfect for group travel, corporate trips, family outings, outstation journeys, and leisure trips, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Bhor offers well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Bhor comes with skilled and courteous drivers familiar with Bhor routes, Pune highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Bhor for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Bhor provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Bhor is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Bhor are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Bhor guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Bhor available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Bhor can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Bhor?',
        answer: 'You can book Urbania On Rent in Bhor via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Bhor?',
        answer: 'Urbania On Rent in Bhor offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Bhor are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Bhor allows flexible pickup and drop locations across Bhor, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Bhor available 24x7?',
        answer: 'Yes, Urbania On Rent in Bhor operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Bhor accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Bhor is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Pawar',
        feedback: 'Urbania On Rent in Bhor made our family trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shital More',
        feedback: 'We hired Urbania On Rent in Bhor for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ramesh Jadhav',
        feedback: 'Urbania On Rent in Bhor provided smooth and hassle-free travel for our group trip. Highly recommended.',
        rating: 5,
    },
];




















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Bhor",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-bhor.jpg",
  "description": "Urbania On Rent in Bhor offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Bhor and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-bhor"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Bhor | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Bhor for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Bhor Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Bhor, Bhor Urbania Bus Hire, Urbania Rental Service Bhor, Urbania AC Bus on Rent Bhor, Corporate Urbania Hire Bhor, Urbania for Outstation Bhor, Urbania Airport Transfer Bhor, Luxury Urbania Bhor, Affordable Urbania Hire Bhor, Chauffeur Driven Urbania Bhor, Urbania for Wedding Events Bhor, Urbania for Office Trips Bhor, Best Urbania Rental Bhor, Urbania Group Travel Bhor, Reliable Urbania Hire Bhor"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/100.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinbhor;